import React from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'
type Props = {
  children: JSX.Element | JSX.Element[],
}
const ProtectedRoute = ({ children }: Props): JSX.Element => (<>{children}</>)

export default withAuthenticationRequired(ProtectedRoute, {
  onRedirecting: () => (<div>Redirecting you to the login page...</div>)
})